import { useEffect, useRef } from "react"

export function usePreviousValue<Type>(
    value: Type | undefined,
): Type | undefined {
    const ref = useRef<Type | undefined>(undefined)

    useEffect(() => {
        ref.current = value
    }, [value])

    return ref.current
}
